import { create } from "zustand";
import { safeStorage } from "@/utils/storage";

export type Appearance = "light" | "dark";

interface UIState {
    appearance: Appearance;
    menuOpen: boolean;
    cartOpen: boolean;
    setMenuOpen: (open: boolean) => void;
    setCartOpen: (open: boolean) => void;
    toggleAppearance: () => void;
    setAppearance: (appearance: Appearance) => void;
}

function initialAppearance(): Appearance {
    return safeStorage.getItem("pitango-appearance") === "dark" ? "dark" : "light";
}

/**
 * Cross-page browser UI state. Menu and cart actions are mutually exclusive;
 * transient state used by only one component should remain local to it.
 */
export const useUIStore = create<UIState>((set, get) => ({
    appearance: initialAppearance(),
    menuOpen: false,
    cartOpen: false,
    setMenuOpen: menuOpen => set({ menuOpen, cartOpen: menuOpen ? false : get().cartOpen }),
    setCartOpen: cartOpen => set({ cartOpen, menuOpen: cartOpen ? false : get().menuOpen }),
    toggleAppearance: () => {
        const appearance = get().appearance === "dark" ? "light" : "dark";
        safeStorage.setItem("pitango-appearance", appearance);
        set({ appearance });
    },
    setAppearance: appearance => {
        safeStorage.setItem("pitango-appearance", appearance);
        set({ appearance });
    }
}));
